var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project" }, [
    _c("div", { staticClass: "view-content" }, [
      _c("div", { staticClass: "columns is-multiline is-variable is-full" }, [
        _c(
          "div",
          {
            staticClass:
              "column is-full is-full-tablet is-full-touch timeline-and-buttons",
          },
          [
            _c("project-timeline"),
            _vm._v(" "),
            _c("div", { staticClass: "state-and-date-container" }, [
              _c("div", { staticClass: "start-date-container" }, [
                _c("div", { staticClass: "project-date-label" }, [
                  _vm._v("\n              Project starts\n            "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "date-picked" }, [
                  _vm.startDateFormatted !== ""
                    ? _c("p", [_vm._v(_vm._s(_vm.startDateFormatted))])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "select-date-button-icon" },
                  [
                    _c("b-datepicker", {
                      attrs: {
                        "mobile-native": false,
                        "append-to-body": "",
                        position: "is-bottom-left",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "trigger",
                          fn: function () {
                            return [
                              _c(
                                "b-button",
                                [
                                  _c("fa", {
                                    staticClass: "calendar-icon",
                                    attrs: { icon: "calendar-plus" },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.selectedStartDate,
                        callback: function ($$v) {
                          _vm.selectedStartDate = $$v
                        },
                        expression: "selectedStartDate",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "state-selector-container" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "project-state-label" },
                  [
                    _vm.selectedState
                      ? _c("fa", {
                          staticClass: "state-icon",
                          attrs: { icon: _vm.selectedState.icon },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedState
                      ? _c("p", [_vm._v(_vm._s(_vm.selectedState.label))])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "select-date-button-icon" },
                  [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          "append-to-body": "",
                          "aria-role": "list",
                          "max-height": "400px",
                          position: "is-bottom-left",
                          scrollable: "",
                          type: "is-primary",
                        },
                        on: { change: _vm.setNewState },
                        scopedSlots: _vm._u([
                          {
                            key: "trigger",
                            fn: function () {
                              return [
                                _c(
                                  "b-button",
                                  [
                                    _c("fa", {
                                      staticClass: "state-picker-icon",
                                      style: { color: "#fff" },
                                      attrs: { icon: "chevron-circle-down" },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.selectedState,
                          callback: function ($$v) {
                            _vm.selectedState = $$v
                          },
                          expression: "selectedState",
                        },
                      },
                      [
                        _vm._v(" "),
                        _vm._l(_vm.availableStates, function (state, index) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: index,
                              attrs: { value: state, "aria-role": "listitem" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "media" },
                                [
                                  _c("b-icon", {
                                    staticClass: "media-left",
                                    attrs: {
                                      icon: state.icon,
                                      size: "is-small",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "media-content" }, [
                                    _c("h3", [_vm._v(_vm._s(state.label))]),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column is-half-desktop is-full-tablet is-full-touch",
          },
          [
            _c(
              "div",
              { staticClass: "box", class: { short: !_vm.show.details } },
              [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column is-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "container__sub-title is-full",
                        on: {
                          click: function ($event) {
                            return _vm.toggleMinimise("details")
                          },
                        },
                      },
                      [
                        _c("h1", { staticClass: "title has-size-4" }, [
                          _vm._v("Project Details"),
                        ]),
                        _vm._v(" "),
                        _vm.deviceIsMobile
                          ? _c(
                              "div",
                              { staticClass: "minimise" },
                              [
                                _c("fa", {
                                  style: { color: "#fff" },
                                  attrs: {
                                    icon: _vm.show.details
                                      ? "chevron-down"
                                      : "chevron-right",
                                    size: "1x",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-modal",
                          {
                            attrs: {
                              "destroy-on-hide": false,
                              "aria-modal": "",
                              "aria-role": "dialog",
                              "close-button-aria-label": "Close",
                              "has-modal-card": "",
                              "trap-focus": "",
                            },
                            model: {
                              value: _vm.sapAssessmentModal,
                              callback: function ($$v) {
                                _vm.sapAssessmentModal = $$v
                              },
                              expression: "sapAssessmentModal",
                            },
                          },
                          [
                            !_vm.deviceIsMobile
                              ? _c(
                                  "section",
                                  { staticClass: "sapAssessmentModalClass" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "sapAssessmentModalHeader",
                                      },
                                      [
                                        _c("h1", [
                                          _vm._v("Request Sent Successfully"),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "sapAssessmentModalText" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "We have sent your request for an SAP Assessment to a member of our team and they will be in\n                        touch shortly"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "sapModalButtonDiv" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "sapModalButton",
                                            on: {
                                              click:
                                                _vm.closeSapAssessmentModal,
                                            },
                                          },
                                          [_vm._v("Close")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("modal-form", {
                                      on: {
                                        close: _vm.closeSapAssessmentModal,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.deviceIsMobile
                              ? _c(
                                  "section",
                                  {
                                    staticClass:
                                      "sapAssessmentModalClassMobile",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "sapAssessmentModalHeader",
                                      },
                                      [
                                        _c("h1", [
                                          _vm._v("Request Sent Successfully"),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "sapAssessmentModalText" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "We have sent your request for an SAP Assessment to a member of our team and they will be in\n                        touch shortly"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "sapModalButtonDiv" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "sapModalButton",
                                            on: {
                                              click:
                                                _vm.closeSapAssessmentModal,
                                            },
                                          },
                                          [_vm._v("Close")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("modal-form", {
                                      on: {
                                        close: _vm.closeSapAssessmentModal,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.show.details
                      ? _c("div", { staticClass: "content" }, [
                          _c("div", { staticClass: "box short white" }, [
                            _c("div", { staticClass: "columns is-mobile" }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("div", { staticClass: "column is-half" }, [
                                _c("p", { staticClass: "has-text-right" }, [
                                  _vm._v(_vm._s(_vm.project.ref)),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "box short white" }, [
                            _c("div", { staticClass: "columns is-mobile" }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("div", { staticClass: "column is-half" }, [
                                _c("p", { staticClass: "has-text-right" }, [
                                  _vm._v(_vm._s(_vm.projectClient)),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "box short white" }, [
                            _c("div", { staticClass: "columns" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "column",
                                  class: {
                                    "is-6": _vm.deviceIsMobile,
                                    "is-5": !_vm.deviceIsMobile,
                                  },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "has-text-weight-bold is-size-6",
                                    },
                                    [_vm._v("Project Address")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "column address-column",
                                  class: {
                                    "is-6": _vm.deviceIsMobile,
                                    "is-7": !_vm.deviceIsMobile,
                                  },
                                },
                                [
                                  _vm.projectAddress.line1
                                    ? _c(
                                        "p",
                                        { staticClass: "has-text-left" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.projectAddress.line1)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.projectAddress.line2
                                    ? _c(
                                        "p",
                                        { staticClass: "has-text-left" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.projectAddress.line2)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.projectAddress.town
                                    ? _c(
                                        "p",
                                        { staticClass: "has-text-left" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.projectAddress.town)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.projectAddress.postcode
                                    ? _c(
                                        "p",
                                        { staticClass: "has-text-left" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.projectAddress.postcode)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "box short white" }, [
                            _c("div", { staticClass: "columns is-mobile" }, [
                              _vm._m(3),
                              _vm._v(" "),
                              _c("div", { staticClass: "column is-half" }, [
                                _c("p", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currencyNotReduced")(
                                        _vm.projectTotal
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "box short white" }, [
                            _c("div", { staticClass: "columns is-mobile" }, [
                              _vm._m(4),
                              _vm._v(" "),
                              _c("div", { staticClass: "column is-half" }, [
                                _c("p", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("title")(_vm.projectState))
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "box short white" }, [
                            _c("div", { staticClass: "columns" }, [
                              _vm._m(5),
                              _vm._v(" "),
                              _c("div", { staticClass: "column is-6" }, [
                                _c("p", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("title")(_vm.estimateState))
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column is-half-desktop is-full-tablet is-full-touch",
          },
          [
            _c(
              "div",
              { staticClass: "box", class: { short: !_vm.show.reports } },
              [
                _c(
                  "div",
                  {
                    staticClass: "container__sub-title is-full",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMinimise("reports")
                      },
                    },
                  },
                  [
                    _c(
                      "h1",
                      {
                        staticClass: "title has-size-4",
                        staticStyle: { "margin-bottom": "1.5rem" },
                      },
                      [_vm._v("Reports")]
                    ),
                    _vm._v(" "),
                    _vm.deviceIsMobile
                      ? _c(
                          "div",
                          { staticClass: "minimise" },
                          [
                            _c("fa", {
                              style: { color: "#fff" },
                              attrs: {
                                icon: _vm.show.reports
                                  ? "chevron-down"
                                  : "chevron-right",
                                size: "1x",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.show.reports && _vm.files
                  ? _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c("file-table", {
                          attrs: {
                            files: {
                              builderReports: _vm.files.builderReports,
                              clientReports: _vm.files.clientReports,
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column is-half-desktop is-full-tablet is-full-touch",
          },
          [
            _c(
              "div",
              { staticClass: "box", class: { short: !_vm.show.plots } },
              [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column is-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "container__sub-title is-full",
                        on: {
                          click: function ($event) {
                            return _vm.toggleMinimise("plots")
                          },
                        },
                      },
                      [
                        _c("h1", { staticClass: "title has-size-4" }, [
                          _vm._v("Plots Breakdown"),
                        ]),
                        _vm._v(" "),
                        _vm.deviceIsMobile
                          ? _c(
                              "div",
                              { staticClass: "minimise" },
                              [
                                _c("fa", {
                                  style: { color: "#fff" },
                                  attrs: {
                                    icon: _vm.show.plots
                                      ? "chevron-down"
                                      : "chevron-right",
                                    size: "1x",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.show.plots
                      ? _c(
                          "div",
                          { staticClass: "content scrollable" },
                          [
                            _vm._l(_vm.plots, function (plot, index) {
                              return _c(
                                "div",
                                [
                                  _c(
                                    "b-collapse",
                                    {
                                      staticClass: "card",
                                      attrs: {
                                        open: _vm.plots.length === 1,
                                        animation: "slide",
                                        "aria-id": "contentIdForA11y3",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          _vm.plots.length === 1
                                            ? {
                                                key: "trigger",
                                                fn: function (props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "card-header",
                                                        attrs: {
                                                          "aria-controls":
                                                            "contentIdForA11y3",
                                                          role: "button",
                                                        },
                                                      },
                                                      [
                                                        _c("p", {
                                                          staticClass:
                                                            "card-header-title",
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "plot-header-title",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "title"
                                                                  )(plot.name)
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "plot-header-total singleTotal",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currencyNotReduced"
                                                                    )(
                                                                      plot
                                                                        .totals
                                                                        .estimate
                                                                        .total
                                                                    )
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("p"),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              }
                                            : {
                                                key: "trigger",
                                                fn: function (props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "card-header",
                                                        attrs: {
                                                          "aria-expanded":
                                                            props.open,
                                                          "aria-controls":
                                                            "contentIdForA11y3",
                                                          role: "button",
                                                        },
                                                      },
                                                      [
                                                        _c("p", {
                                                          staticClass:
                                                            "card-header-title",
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "plot-header-title-multi",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "title"
                                                                  )(plot.name)
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "plot-header-total",
                                                          },
                                                          [
                                                            _c("p", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currencyNotReduced"
                                                                    )(
                                                                      plot
                                                                        .totals
                                                                        .estimate
                                                                        .total
                                                                    )
                                                                  )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("p"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "card-header-icon",
                                                          },
                                                          [
                                                            _c("b-icon", {
                                                              attrs: {
                                                                icon: props.open
                                                                  ? "chevron-up"
                                                                  : "chevron-down",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "card-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "content" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "plot-sums" },
                                                [
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate
                                                      .material
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-weight-bold has-text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Material\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate
                                                      .material
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-right is-size-6",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currencyNotReduced"
                                                                )(
                                                                  plot.totals
                                                                    .estimate
                                                                    .material
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "plot-sums" },
                                                [
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate.plant
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-weight-bold has-text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Plant\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate.plant
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-right is-size-6",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currencyNotReduced"
                                                                )(
                                                                  plot.totals
                                                                    .estimate
                                                                    .plant
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "plot-sums" },
                                                [
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate.labour
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-weight-bold has-text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Labour\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate.labour
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-right is-size-6",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currencyNotReduced"
                                                                )(
                                                                  plot.totals
                                                                    .estimate
                                                                    .labour
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "plot-sums" },
                                                [
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate.pcSums
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-weight-bold has-text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "PC\n                            Sums\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate.pcSums
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-right is-size-6",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currencyNotReduced"
                                                                )(
                                                                  plot.totals
                                                                    .estimate
                                                                    .pcSums
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "plot-sums" },
                                                [
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate
                                                      .professionalFees
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-weight-bold has-text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Professional Fees\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.hasValidNumberAndAboveZero(
                                                    plot.totals.estimate
                                                      .professionalFees
                                                  )
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-right is-size-6",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currencyNotReduced"
                                                                )(
                                                                  plot.totals
                                                                    .estimate
                                                                    .professionalFees
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "plot-totals" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "plot-sums",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "has-text-weight-bold has-text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                              Total\n                            "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.hasValidNumberAndAboveZero(
                                                        plot.totals.estimate
                                                          .total
                                                      )
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "has-text-right is-size-6",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currencyNotReduced"
                                                                    )(
                                                                      plot
                                                                        .totals
                                                                        .estimate
                                                                        .total
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "plot-sums",
                                                    },
                                                    [
                                                      _vm.hasValidNumberAndAboveZero(
                                                        plot.totals.estimate
                                                          .clientTotalExVat
                                                      )
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "has-text-weight-bold has-text-left",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              Client Total\n                            "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.hasValidNumberAndAboveZero(
                                                        plot.totals.estimate
                                                          .clientTotalExVat
                                                      )
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "has-text-right is-size-6",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currencyNotReduced"
                                                                    )(
                                                                      plot
                                                                        .totals
                                                                        .estimate
                                                                        .clientTotalExVat
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _vm.plots.length === 0
                              ? _c("div", { staticClass: "box short white" }, [
                                  _c(
                                    "p",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v("No plots available")]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "column is-half-desktop is-full-tablet is-full-touch",
          },
          [
            _c(
              "div",
              { staticClass: "box", class: { short: !_vm.show.plans } },
              [
                _c(
                  "div",
                  {
                    staticClass: "container__sub-title is-full",
                    on: {
                      click: function ($event) {
                        return _vm.toggleMinimise("plans")
                      },
                    },
                  },
                  [
                    _c(
                      "h1",
                      {
                        staticClass: "title has-size-4",
                        staticStyle: { "margin-bottom": "1.5rem" },
                      },
                      [_vm._v("Plans")]
                    ),
                    _vm._v(" "),
                    _vm.deviceIsMobile
                      ? _c(
                          "div",
                          { staticClass: "minimise" },
                          [
                            _c("fa", {
                              style: { color: "#fff" },
                              attrs: {
                                icon: _vm.show.plans
                                  ? "chevron-down"
                                  : "chevron-right",
                                size: "1x",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.show.plans && _vm.files
                  ? _c(
                      "div",
                      { staticClass: "table-container" },
                      [
                        _c("file-table", {
                          attrs: {
                            files: {
                              plans: _vm.files.plans,
                              annotatedPlans: _vm.files.annotatedPlans,
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "project-state-label" }, [
      _c("p", [_vm._v("Project state")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-half" }, [
      _c("p", { staticClass: "has-text-weight-bold is-size-6" }, [
        _vm._v("Project Ref"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-half" }, [
      _c("p", { staticClass: "has-text-weight-bold is-size-6" }, [
        _vm._v("Project Client"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-half" }, [
      _c("p", { staticClass: "has-text-weight-bold is-size-6" }, [
        _vm._v("Client Total (ex VAT)"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-half" }, [
      _c("p", { staticClass: "has-text-weight-bold is-size-6" }, [
        _vm._v("Project Status"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-6" }, [
      _c("p", { staticClass: "has-text-weight-bold is-size-6" }, [
        _vm._v("Estimate Status"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }